// extracted by mini-css-extract-plugin
export var card = "_ao-0";
export var failedIcon = "_ao-4";
export var failedIconBadge = "_ao-3";
export var icon = "_ao-1";
export var successIcon = "_ao-2";